var cnoise = `
	vec4 permute(vec4 x){return mod(((x*34.0)+1.0)*x, 289.0);}
	vec4 taylorInvSqrt(vec4 r){return 1.79284291400159 - 0.85373472095314 * r;}
	vec3 fade(vec3 t) {return t*t*t*(t*(t*6.0-15.0)+10.0);}

	float cnoise(vec3 P){
	  vec3 Pi0 = floor(P); // Integer part for indexing
	  vec3 Pi1 = Pi0 + vec3(1.0); // Integer part + 1
	  Pi0 = mod(Pi0, 289.0);
	  Pi1 = mod(Pi1, 289.0);
	  vec3 Pf0 = fract(P); // Fractional part for interpolation
	  vec3 Pf1 = Pf0 - vec3(1.0); // Fractional part - 1.0
	  vec4 ix = vec4(Pi0.x, Pi1.x, Pi0.x, Pi1.x);
	  vec4 iy = vec4(Pi0.yy, Pi1.yy);
	  vec4 iz0 = Pi0.zzzz;
	  vec4 iz1 = Pi1.zzzz;

	  vec4 ixy = permute(permute(ix) + iy);
	  vec4 ixy0 = permute(ixy + iz0);
	  vec4 ixy1 = permute(ixy + iz1);

	  vec4 gx0 = ixy0 / 7.0;
	  vec4 gy0 = fract(floor(gx0) / 7.0) - 0.5;
	  gx0 = fract(gx0);
	  vec4 gz0 = vec4(0.5) - abs(gx0) - abs(gy0);
	  vec4 sz0 = step(gz0, vec4(0.0));
	  gx0 -= sz0 * (step(0.0, gx0) - 0.5);
	  gy0 -= sz0 * (step(0.0, gy0) - 0.5);

	  vec4 gx1 = ixy1 / 7.0;
	  vec4 gy1 = fract(floor(gx1) / 7.0) - 0.5;
	  gx1 = fract(gx1);
	  vec4 gz1 = vec4(0.5) - abs(gx1) - abs(gy1);
	  vec4 sz1 = step(gz1, vec4(0.0));
	  gx1 -= sz1 * (step(0.0, gx1) - 0.5);
	  gy1 -= sz1 * (step(0.0, gy1) - 0.5);

	  vec3 g000 = vec3(gx0.x,gy0.x,gz0.x);
	  vec3 g100 = vec3(gx0.y,gy0.y,gz0.y);
	  vec3 g010 = vec3(gx0.z,gy0.z,gz0.z);
	  vec3 g110 = vec3(gx0.w,gy0.w,gz0.w);
	  vec3 g001 = vec3(gx1.x,gy1.x,gz1.x);
	  vec3 g101 = vec3(gx1.y,gy1.y,gz1.y);
	  vec3 g011 = vec3(gx1.z,gy1.z,gz1.z);
	  vec3 g111 = vec3(gx1.w,gy1.w,gz1.w);

	  vec4 norm0 = taylorInvSqrt(vec4(dot(g000, g000), dot(g010, g010), dot(g100, g100), dot(g110, g110)));
	  g000 *= norm0.x;
	  g010 *= norm0.y;
	  g100 *= norm0.z;
	  g110 *= norm0.w;
	  vec4 norm1 = taylorInvSqrt(vec4(dot(g001, g001), dot(g011, g011), dot(g101, g101), dot(g111, g111)));
	  g001 *= norm1.x;
	  g011 *= norm1.y;
	  g101 *= norm1.z;
	  g111 *= norm1.w;

	  float n000 = dot(g000, Pf0);
	  float n100 = dot(g100, vec3(Pf1.x, Pf0.yz));
	  float n010 = dot(g010, vec3(Pf0.x, Pf1.y, Pf0.z));
	  float n110 = dot(g110, vec3(Pf1.xy, Pf0.z));
	  float n001 = dot(g001, vec3(Pf0.xy, Pf1.z));
	  float n101 = dot(g101, vec3(Pf1.x, Pf0.y, Pf1.z));
	  float n011 = dot(g011, vec3(Pf0.x, Pf1.yz));
	  float n111 = dot(g111, Pf1);

	  vec3 fade_xyz = fade(Pf0);
	  vec4 n_z = mix(vec4(n000, n100, n010, n110), vec4(n001, n101, n011, n111), fade_xyz.z);
	  vec2 n_yz = mix(n_z.xy, n_z.zw, fade_xyz.y);
	  float n_xyz = mix(n_yz.x, n_yz.y, fade_xyz.x); 
	  return 2.2 * n_xyz;
	}
`;


var WaterfallShader = {
  fragmentShader : `
  	varying vec2 vUv;

	uniform vec3 color1;
	uniform vec3 color2;
	uniform vec3 color3;
	uniform sampler2D noiseMap;
		
	void main(void)
	{	
		float noise = texture2D(noiseMap,vUv).r*0.5;
		
		vec3 color = mix(color1,color2,noise);
		color = mix(color,color3,vUv.x*1.2-0.5);
		gl_FragColor = vec4(color,1.0);
	}
   `,
  vertexShader : `
  	varying vec2 vUv;
  	uniform float time;
			
	void main()
	{

		vUv = vec2(uv.x,uv.y*0.2+time*0.0003);

		vec4 mvPosition = modelViewMatrix * vec4( position, 1.0 );
		gl_Position = projectionMatrix * mvPosition;
	}
  `
};

var PlantsShader = {
  fragmentShader : `
  	varying vec2 vUv;

	uniform sampler2D map;
		
	void main(void)
	{	
		gl_FragColor = texture2D(map,vUv).rgba;
	}
   `,
  vertexShader : `
  	varying vec2 vUv;
  	uniform float time;
			
	void main()
	{

		vUv = uv;

		vec3 myPosition = position;
		myPosition.x += sin(time*0.001)*uv.y*20.0;

		vec4 mvPosition = modelViewMatrix * vec4( myPosition, 1.0 );
		gl_Position = projectionMatrix * mvPosition;
	}
  `
};

var FishShader = {
  fragmentShader : `
  	varying vec2 vUv;

	uniform sampler2D map;
		
	void main(void)
	{	
		gl_FragColor = texture2D(map,vUv).rgba;
		gl_FragColor.a *= 0.5;
	}
   `,
  vertexShader : `
  	varying vec2 vUv;
  	uniform float time;

  	vec4 quat_from_axis_angle(vec3 axis, float angle)
	{ 
	  vec4 qr;
	  float half_angle = (angle * 0.5) * 3.14159 / 180.0;
	  qr.x = axis.x * sin(half_angle);
	  qr.y = axis.y * sin(half_angle);
	  qr.z = axis.z * sin(half_angle);
	  qr.w = cos(half_angle);
	  return qr;
	}

	vec4 quat_conj(vec4 q)
	{ 
	  return vec4(-q.x, -q.y, -q.z, q.w); 
	}
	  
	vec4 quat_mult(vec4 q1, vec4 q2)
	{ 
	  vec4 qr;
	  qr.x = (q1.w * q2.x) + (q1.x * q2.w) + (q1.y * q2.z) - (q1.z * q2.y);
	  qr.y = (q1.w * q2.y) - (q1.x * q2.z) + (q1.y * q2.w) + (q1.z * q2.x);
	  qr.z = (q1.w * q2.z) + (q1.x * q2.y) - (q1.y * q2.x) + (q1.z * q2.w);
	  qr.w = (q1.w * q2.w) - (q1.x * q2.x) - (q1.y * q2.y) - (q1.z * q2.z);
	  return qr;
	}

	vec3 rotate_vertex_position(vec3 position, vec3 axis, float angle)
	{ 
	  vec4 qr = quat_from_axis_angle(axis, angle);
	  vec4 qr_conj = quat_conj(qr);
	  vec4 q_pos = vec4(position.x, position.y, position.z, 0);
	  
	  vec4 q_tmp = quat_mult(qr, q_pos);
	  qr = quat_mult(q_tmp, qr_conj);
	  
	  return vec3(qr.x, qr.y, qr.z);
	}
			
	void main()
	{

		vUv = uv;

		vec3 myPosition = position;
		myPosition = rotate_vertex_position( myPosition, vec3(0,1,0),sin(time*0.005)*20.0*uv.x);

		

		vec4 mvPosition = modelViewMatrix * vec4( myPosition, 1.0 );
		gl_Position = projectionMatrix * mvPosition;
	}
  `
};

var ParticlesShader = {
	fragmentShader: `
		uniform sampler2D pointTexture;
		uniform float mainOpacity;
		void main() {
			gl_FragColor = vec4( vec3(1.0,1.0,1.0), 1.0 );
			gl_FragColor = gl_FragColor * texture2D( pointTexture, gl_PointCoord );
			gl_FragColor.a *= mainOpacity;
		}
   `,
  	vertexShader: `
  		attribute float size;
		uniform float time;

		`+cnoise+`

		void main() {
			vec3 newPosition = vec3(0,0,0);

			newPosition.x = position.x + cnoise(vec3(position.x,time*0.2,0.0))*40.0;
			newPosition.y = position.y + cnoise(vec3(position.y,time*0.2,0.0))*40.0;
			newPosition.z = position.z + cnoise(vec3(position.z,time*0.2,0.0))*40.0;
			
			float mySize = size*2.0 * cnoise(vec3(position.x,position.y,time))+2.0 * 0.5; 

			vec4 mvPosition = modelViewMatrix * vec4( newPosition, 1.0 );
			gl_PointSize = mySize*0.08;
			gl_Position = projectionMatrix * mvPosition;
		}
	`
};

export { WaterfallShader,PlantsShader,FishShader,ParticlesShader };

